// extracted by mini-css-extract-plugin
module.exports = {"appLoader":"YMCYG","icons":"fnsET","icon":"QHkRc","appLoader_hidden":"_6hFDd","spin":"BuHg7"};